import { RootState } from '@/store'
import { User } from '@/types'

export default function selectUserUtility(state: RootState) {
  const user = state.user.user as User | undefined
  return user?.profile.utility
}
